
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import { showErrorFlash, showFlash } from '~/lib/flash';
import { validateWithScroll } from '~/lib/scrollValidator';

interface IUploadedPhoto {
    src: string;
    file: File;
}

@Component({
    components: {
        btn: require('~/components/form/button').default,
        formField: require('~/components/form/form-field/').default,
        VueRecaptcha: require('vue-recaptcha').default,
    },
    computed: mapState(['user']),
})
export default class ReviewPageComponent extends Vue {

    @prop()
    public productId: number;

    public showField = false;
    public user: User;
    public rating = 5;
    public previewRating = 5;
    public message = '';
    public name = '';
    public email = '';
    public photos: IUploadedPhoto[] = [];
    loading = false;

    supportedPhotoTypes = [
        'image/jpeg',
        'image/png',
    ];

    private siteKey = '6LcNYskUAAAAAKJCkqqwtLbg6TIV-xBU7QEtI2oo';

    toggleReviewsBlock() {
        // if (!this.user) {
        //     this.$store.commit('setLoginFormState', true);
        //     return;
        // }

        this.showField = !this.showField;
        this.rating = 5;
        this.message = '';
        this.name = '';
        this.email = '';
        this.photos = [];
    }

    startSend() {

        if (this.loading || !this.valid) {
            return;
        }

        this.loading = true;
        (this.$refs.invisibleRecaptcha as any).execute();
    }


    async sendReview(response: string) {

        try {
            await this.$store.dispatch('RestFormRequest', {
                url: '/catalog/reviews/add',
                params: {
                    token: response,
                    name: this.name,
                    email: this.email,
                    offer_id: this.productId,
                    rating: this.rating,
                    message: this.message,
                    photos: this.photos
                }
            });

            showFlash({
                text: 'Отзыв будет добавлен после проверки модератором',
                type: 'success',
                timeout: 3000,
            });

            this.showField = false;
        } catch (err) {
            console.error(err);
            showErrorFlash("Ошибка при отправке отзыва");
        } finally {
            this.loading = false;
        }
    }

    photoChanged(event, idx: number) {

        const w = window.URL || window.webkitURL;
        const file: File = event.target.files[0];

        if (file.size / 1024 / 1024 > 4) {
            showErrorFlash(`${file.name}: слишком большой файл`);
            return;
        } else if (!this.supportedPhotoTypes.includes(file.type)) {
            showErrorFlash(`${file.name}: неверный тип файла`);
            return;
        }

        this.photos[idx].file = file;
        this.photos[idx].src = w.createObjectURL(file);
    }

    appendPhotos(event) {

        const w = window.URL || window.webkitURL;
        const fileList = (event.target.files as FileList);

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];

            if (file.size / 1024 / 1024 > 4) {
                showErrorFlash(`${file.name}: слишком большой файл`);
                continue;
            } else if (!this.supportedPhotoTypes.includes(file.type)) {
                showErrorFlash(`${file.name}: неверный тип файла`);
                continue;
            }

            this.photos.push({
                src: w.createObjectURL(file),
                file,
            });

            if (this.photos.length >= 6) {
                return;
            }
        }
    }

    removePhoto(idx: number) {
        this.photos.splice(idx, 1);
    }

    get triggerButtonText() {
        return this.showField ? 'Закрыть отзыв' : 'Написать отзыв';
    }

    get inputAccept() {
        return this.supportedPhotoTypes.join(',');
    }

    get valid(): boolean {

        if (this.user) {
            return true;
        }

        return validateWithScroll(this, ['nameField', 'emailField']);
    }

    @watch('user')
    onUserLogout() {
        if (!this.user) {
            this.showField = false;
        }
    }
}
